import { useOutletContext } from "react-router-dom";
import ChromaComponent from "V2.0/HomePages/HomeModule/ChromaComponent";
import { IntegrationShell } from "../common/Shell";

export function ChromaDBIntegration() {
  const { projectId, settings, fetchSettings, isViewOnly } = useOutletContext();

  return (
    <IntegrationShell>
      <ChromaComponent
        projectId={projectId}
        settings={settings}
        fetchSettings={fetchSettings}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
